import { render, staticRenderFns } from "./IpAnalysis.vue?vue&type=template&id=15112770&"
import script from "@/scripts/components/column/ipAnalysis.js?vue&type=script&lang=js&"
export * from "@/scripts/components/column/ipAnalysis.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports